<script>
  import Container from "./Container.svelte";

  export let width;
  export let height;// = 315;
  export let frameborder = 0;
  export let title;
  export let src;
  export let allow;
  export let allowfullscreen = true;
</script>
<Container>
  <iframe width={width} height={height} src={src}
    title={title}
    frameborder={frameborder} allow={allow}
    allowfullscreen={allowfullscreen}
  ></iframe>
</Container>